











import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { BillingSetupService } from './service/billing-setup-service';

@Component({})
export default class DirectTierSelection extends Vue {
	@InjectReactive('billingSetupService') service!: BillingSetupService;

	public get directTiers(): { value: string; text: string }[] {
		if (!this.service.product.type) {
			return [];
		}
		const tiers: string[] | null = this.service.directTiers;
		if (tiers === null) {
			return [];
		}
		return tiers.map((tier: string) => ({
			value: tier,
			text: this.$options.filters!.titleCase(tier),
		}));
	}
}
